import React from 'react'
import { WemoloLoading } from '../Wemolo'

const AppLoading = () => {
    return <WemoloLoading fullPage />
}

export default AppLoading
